export function telMask() {
  function digitsOnly( s ) {
    return ( s || '' ).replace( /\D+/g, '' );
  }

  function caretToEnd( el ) {
    const len = el.value.length;
    el.setSelectionRange( len, len );
  }

  function normalizeUa( digits ) {
    if ( digits.startsWith( '0' ) ) digits = '38' + digits;
    if ( digits.startsWith( '80' ) ) digits = '3' + digits;

    if ( digits.startsWith( '380' ) ) return digits.slice( 0, 12 );
    if ( digits.length === 9 ) return ( '380' + digits ).slice( 0, 12 );

    return digits.slice( 0, 12 );
  }

  function formatUa( digits ) {
    const v = digits.startsWith( '380' ) ? digits : ( '380' + digits ).slice( 0, 12 );
    const rest = v.slice( 3 ); // after 380

    // Empty state always with trailing space
    if ( rest.length === 0 ) return '+380 ';

    let out = '+380';
    out += ' ' + rest.slice( 0, 2 );
    if ( rest.length > 2 ) out += ' ' + rest.slice( 2, 5 );
    if ( rest.length > 5 ) out += ' ' + rest.slice( 5, 7 );
    if ( rest.length > 7 ) out += ' ' + rest.slice( 7, 9 );

    return out;
  }

  function ensurePrefixAndFormat( el ) {
    let d = digitsOnly( el.value );

    // Treat just "380" (prefix only) as empty state
    if ( d === '' || d === '380' ) {
      el.value = '+380 ';
      caretToEnd( el );
      return;
    }

    d = normalizeUa( d );

    if ( !d.startsWith( '380' ) ) {
      d = ( '380' + d ).slice( 0, 12 );
    }

    el.value = formatUa( d );
  }

  // INPUT
  document.addEventListener( 'input', function ( e ) {
    const el = e.target;
    if ( !el || el.type !== 'tel' ) return;

    ensurePrefixAndFormat( el );
  } );

  // FOCUS
  document.addEventListener( 'focusin', function ( e ) {
    const el = e.target;
    if ( !el || el.type !== 'tel' ) return;

    if ( el.value.trim() === '' ) {
      el.value = '+380 ';
      caretToEnd( el );
      return;
    }

    if ( el.value.indexOf( '+380' ) !== 0 ) {
      ensurePrefixAndFormat( el );
      caretToEnd( el );
      return;
    }

    // If it is "+380" without space, fix it
    if ( el.value === '+380' ) {
      el.value = '+380 ';
      caretToEnd( el );
    }
  } );

  // KEYDOWN (lock prefix)
  document.addEventListener( 'keydown', function ( e ) {
    const el = e.target;
    if ( !el || el.type !== 'tel' ) return;

    // Repair if somehow missing trailing space
    if ( el.value === '+380' ) {
      el.value = '+380 ';
      caretToEnd( el );
    }

    const prefix = '+380 ';
    const start = el.selectionStart || 0;
    const end = el.selectionEnd || 0;

    // Block deleting inside prefix
    if (
      ( e.key === 'Backspace' && start <= prefix.length ) ||
      ( e.key === 'Delete' && start < prefix.length )
    ) {
      e.preventDefault();
      el.setSelectionRange( prefix.length, prefix.length );
      return;
    }

    // Prevent overwriting prefix by typing while selection overlaps it
    if ( start < prefix.length && end > 0 ) {
      const allowed = [ 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Tab', 'Shift', 'Control', 'Alt' ];
      if ( allowed.indexOf( e.key ) === -1 ) {
        e.preventDefault();
        el.setSelectionRange( prefix.length, prefix.length );
      }
    }
  } );

  // BLUR (cleanup)
  document.addEventListener( 'focusout', function ( e ) {
    const el = e.target;
    if ( !el || el.type !== 'tel' ) return;

    // If user left only prefix (with or without space) -> clear
    if ( el.value.trim() === '+380' ) {
      el.value = '';
      return;
    }

    const d = digitsOnly( el.value );
    if ( d === '' || d === '380' ) {
      el.value = '';
      return;
    }

    ensurePrefixAndFormat( el );
  } );
}
